import {useQuery} from "@tanstack/react-query";
import {fetchDELETE, fetchGET, fetchPOST, fetchPUT} from "./fetch";
import {useMyMutation} from "./mymutation";

const REACT_QUERY_ID_RESULTSFILES = "resultfiles";
const BASE_URL = "/api/resultfiles";

const ResultFileQueryConfig = {
    staleTime: 0,
    cacheTime: 1000 * 60 * 5,
}

export const RESULTFILE_EMPTY = {title: "",file:"",results:[]};

export function useResultFiles() {
    const resultFile = useQuery({
        queryKey: [REACT_QUERY_ID_RESULTSFILES],
        queryFn: async () => await fetchGET(BASE_URL),
        //onError: e => setError(e),
        ...ResultFileQueryConfig
    });
    return {...resultFile, resultfiles: resultFile.data};
}


export function useResultFile(id) {
    const resultFile = useQuery({
        queryKey: [REACT_QUERY_ID_RESULTSFILES, id],
        queryFn: async () => id ? await fetchGET(`${BASE_URL}/${id}`) : {},
        //onError: e => setError(e),
        ...ResultFileQueryConfig
    });
    return {...resultFile, resultFile: resultFile.data};
}

export function useResultFileMutations() {
    async function createFunction(resultFile) {
        if (!resultFile) return;
        return await fetchPOST(BASE_URL, resultFile, false);
    }

    async function editFunction(resultFile) {
        if (!resultFile) return;
        return  await fetchPUT(`${BASE_URL}/${resultFile.id}`, resultFile);
    }

    async function editAddNewFiles(resultFile) {
        if (!resultFile) return;
        return await fetchPUT(`${BASE_URL}/${resultFile.id}/files`, resultFile.fileId);
    }
    async function editAddNewResult(resultFile) {
        if (!resultFile) return;
        return await fetchPUT(`${BASE_URL}/${resultFile.id}/result`, resultFile.resultId);
    }

    async function deleteFunction(resultFile) {
        return await fetchDELETE(`${BASE_URL}/${resultFile.id}`)
    }

    return {
        createResultFile: useMyMutation(createFunction, REACT_QUERY_ID_RESULTSFILES, resultFile => `ResultFile ${resultFile.title} created`),
        editResultFile: useMyMutation(editFunction, REACT_QUERY_ID_RESULTSFILES, resultFile => `ResultFile ${resultFile.title} modified`),
        editAddNewFiles: useMyMutation(editAddNewFiles, REACT_QUERY_ID_RESULTSFILES, resultFile => `ResultFile ${resultFile.title} modified`),
        editAddNewResult:useMyMutation(editAddNewResult,REACT_QUERY_ID_RESULTSFILES, resultFile => `ResultFile ${resultFile.title} modified`),
        deleteResultFile: useMyMutation(deleteFunction, REACT_QUERY_ID_RESULTSFILES, resultFile => `ResultFile ${resultFile.title} deleted.`)
    };

}